import {Clapperboard, ListVideo, LogOut, Plus, Trash2} from "lucide-react";
import type {ReactNode} from "react";
import {Link, NavLink, useNavigate} from "react-router-dom";
import {clearAccessToken} from "../session";

export const AppShell = ({children}: {children: ReactNode}) => {
  const navigate = useNavigate();
  return (
    <div className="app-shell">
      <header className="topbar">
        <Link to="/tasks" className="brand" aria-label="返回任务列表">
          <span className="brand-mark"><Clapperboard size={21} strokeWidth={1.8} /></span>
          <span><b>视频制作台</b><small>BOOK VIDEO STUDIO</small></span>
        </Link>
        <nav className="primary-nav" aria-label="主要导航">
          <NavLink to="/tasks"><ListVideo size={18} />任务</NavLink>
          <NavLink to="/trash"><Trash2 size={18} />回收站</NavLink>
          <NavLink to="/tasks/new"><Plus size={18} />新建</NavLink>
          <button type="button" onClick={() => {clearAccessToken(); navigate("/login");}} aria-label="退出登录">
            <LogOut size={18} /><span>退出</span>
          </button>
        </nav>
      </header>
      <main className="workspace">{children}</main>
    </div>
  );
};
